export default __webpack_public_path__ + "static/media/moodVeryGood.9221be48.png";